/**
 * RailsContainer component.
 */
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled rails container.
 */
const RailsContainer = styled.div<React.CSSProperties>``;

export default withOpacity(RailsContainer);
